<template>
  <div class="model-change">
    <el-container>
      <el-header>
        <div class="total-title">
          <i class="el-icon-tickets" />产品更新说明
        </div>
      </el-header>
      <el-main>
        <el-collapse v-model="activeNames" @change="handleChange">
          <el-collapse-item name="1" style="text-align: left">
            <template slot="title">
              <span class="titleClass">新品上架</span>
            </template>
            <div class="table">
              <el-table
                :data="tableData"
                border
                style="width: 100%"
              >
                <el-table-column
                  prop="productName"
                  label="产品名称"
                  width="300"
                  align="left"
                />
                <el-table-column
                  prop="lastUpdateTime"
                  label="上架时间"
                  width="180"
                  align="left"
                />
                <el-table-column label="产品线/产品大类/产品系列" align="left">
                  <template slot-scope="scope">
                    {{ scope.row.productClassName }}/{{ scope.row.broadHeadingName }}/{{ scope.row.productCategoryName }}
                  </template>
                </el-table-column>
              </el-table>
            </div>
          </el-collapse-item>
          <el-collapse-item name="2" style="text-align: left">
            <template slot="title">
              <span class="titleClass">产品修改</span>
            </template>
            <div class="table">
              <el-table
                :data="tableData2"
                border
                style="width: 100%"
              >
                <el-table-column
                  prop="productName"
                  label="产品名称"
                  width="300"
                  align="left"
                />
                <el-table-column
                  prop="lastUpdateTime"
                  label="变更时间"
                  width="180"
                  align="left"
                />
                <el-table-column
                  prop="address"
                  label="变更后价格"
                  width="180"
                  align="left"
                >
                  <template slot-scope="scope">
                    <span style="background: #EF5455;color: #ffffff;text-align:center;padding: 2px 6px;border-radius: 2px;font-weight: bold">{{ productPriceFormat2(null,null,scope.row.productRetailPrice) }}</span>
                  </template>
                </el-table-column>
                <el-table-column
                  prop="productClassName"
                  label="产品线"
                  align="left"
                />
              </el-table>
            </div>
          </el-collapse-item>
          <el-collapse-item name="3" style="text-align: left">
            <template slot="title">
              <span class="titleClass">促销截止</span>
            </template>
            <div class="table">
              <el-table
                :data="tableData3"
                border
                style="width: 100%"
              >
                <el-table-column
                  prop="productName"
                  label="产品名称"
                  width="300"
                  align="left"
                />
                <el-table-column
                  prop="discountStopTime"
                  label="促销截止时间"
                  width="180"
                  align="left"
                />
                <el-table-column
                  prop="productClassName"
                  label="产品线"
                  align="left"
                />
              </el-table>
            </div>
          </el-collapse-item>
        </el-collapse>
      </el-main>
    </el-container>
  </div>
</template>

<script>
import eventBus from '@/utils/eventBus';
import API from '../api';
import { productPriceFormat2 } from '../utils/numberFormater';
export default {
  name: 'ModelChange',
  data () {
    return {
      tableData: [],
      tableData2: [],
      tableData3: [],
      activeNames: ['1'],
      isInitLongTable: false,
      switchFlgP: true
    };
  },
  mounted () {
    this.getProductChange(1);
    this.getProductChange(2);
    this.getProductChange(3);
  },
  methods: {
    productPriceFormat2,
    handleChange (val) {
      if (this.activeNames.indexOf('3') >= 0 && !this.isInitLongTable) {
        eventBus.$emit('initLongtext');
        this.isInitLongTable = true;
      }
    },
    getProductChange (type) {
      API.getProductChange({ params: { operate: type } }).then((res) => {
        let json = res.data;
        if (json.status === '200') {
          if (type == 1) {
            this.tableData = json.data;
          } else if (type == 2) {
            this.tableData2 = json.data;
          } else if (type == 3) {
            this.tableData3 = json.data;
          }
        } else {
          this.$notify.error(json.err);
        }
      }).catch((e) => {
        this.$notify.error('网络异常！');
        console.error('e', e);
      });
    }
  }
};
</script>

<style type="text/css" scoped>
  .model-change .total-title{
    height: 60px;
    line-height: 60px;
    text-align: left;
  }

  .model-change .total-title .el-icon-tickets{
    font-size: 24px;
    margin-right: 10px;
    color:#36BADE;
    vertical-align: middle;
  }
  .model-change .demo-table-expand {
    font-size: 0;
  }
  .model-change .demo-table-expand label {
    width: 90px;
    color: #99a9bf;
  }
  .model-change .demo-table-expand .el-form-item {
    margin-right: 0;
    margin-bottom: 0;
    width: 50%;
  }
  .model-change .el-main{
    padding-top: 0;
  }
  .model-change .titleClass{
    color: #36BADE;
    font-weight: 700;
    cursor: pointer;
    text-decoration: underline;
    text-align: left;
  }
  .clear{
    clear:both;
  }

  @media screen and (max-width: 1366px) {
    .model-change table tr,
    .model-change table tr th,
    .model-change table tr td{
      height: 2.4rem;
      font-size: 0.8rem;
      padding: 0;
      margin: 0;
    }
  }
</style>
